/**
 * AI feature levels (#1523). A member of a budget team holds one of these;
 * someone in no budget team is view only and gets no AI features. The level
 * is enforced on the server by goapi/pkg/aiaccess once the customer's switch
 * is on (#1537); which feature needs which level comes from the server
 * (useAiAccess). The server accepts 1 to 4 (goapi/pkg/types/budget_teams.go).
 */
export const AI_LEVELS: Record<number, string> = {
  1: 'View only',
  2: 'Insights pane',
  3: 'Insights and agent',
  4: 'Full, including heavy batch',
}

export const MIN_AI_LEVEL = 1
export const MAX_AI_LEVEL = 4

/** Slider marks for the four levels. */
export const AI_LEVEL_MARKS = Object.keys(AI_LEVELS).map((k) => ({ value: Number(k), label: k }))

export const aiLevelLabel = (level: number): string => AI_LEVELS[level] ?? String(level)
